module.exports = __webpack_public_path__ + "3573e98e786de1fe7a58d59d7219125a.png";